export default function round(value) {
  return value.toPrecision(3);
}
